export default class ActiveDesignerView {
  constructor(baseClass = ".aam-designer-init") {
    this.baseClass = baseClass;
    this.baseElement = document.querySelector(baseClass);
  }

  // set view for each [page]
  setActiveView(currentCls) {
    const classesList = [
      "view-landing-wrapper",
      "view-svgOptimisation-wrapper",
      "view-designer-wrapper",
      "view-preview-wrapper"
    ];

    const aamClassList = document.querySelector(this.baseClass).classList;

    // removing existing classes
    classesList.forEach((c) => {
      if (aamClassList.contains(c)) {
        aamClassList.remove(c);
      }
    });

    // add active class
    switch (currentCls) {
      case "view-landing-wrapper":
        aamClassList.add(currentCls);
        break;

      case "view-svgOptimisation-wrapper":
        aamClassList.add(currentCls);
        break;

      case "view-designer-wrapper":
        aamClassList.add(currentCls);
        break;

      case "view-preview-wrapper":
        aamClassList.add(currentCls);
        break;
    }
  }

  // check active view by class - will return boolean
  checkActiveView(cls) {
    let hasClass = false;
    if (cls) {
      if (this.baseElement.classList.contains(cls)) {
        hasClass = true;
      } else {
        hasClass = false;
      }
    }
    return hasClass;
  }

  addClassToView(cls) {
    if(cls) {
      this.baseElement.classList.add(cls);
    }
    
  }
}
